/* eslint-disable camelcase */
import { toast } from 'react-toastify';
import { type UseMutationResult, useMutation, useQueryClient } from 'react-query';
import ToastComponent from '../../components/toast';
import {
  OptionExerciseService,
  Wealthlane_AwardService_Dtos_Response_ResponseDto,
} from '../../services/wealthlane-award-services';

const usePostExerciseListSingleCalculateTax = (
  handleRequest: <T>(request: Promise<T>) => Promise<T | undefined>
): UseMutationResult<
  Wealthlane_AwardService_Dtos_Response_ResponseDto | undefined,
  unknown,
  any,
  unknown
> => {
  const queryClient = useQueryClient();
  return useMutation(
    async (payload: any) => {
      return await handleRequest(
        OptionExerciseService.postApiAwardApiAppOptionExerciseCalculateOptionExerciseTaxForSingleRecord(
          payload
        )
      );
    },
    {
      onSuccess: async (response: any) => {
        if (response != null) {
          toast.success(<ToastComponent label='Success' message='Tax Calculated' />);
          await queryClient.invalidateQueries('getOptionExercisedList');
          await queryClient.invalidateQueries('getOptionExerciseTaxDetail');
          await queryClient.invalidateQueries('getTransactionHistoryTaxDetail');
        }
      },
      onError: (err) => {
        console.log('error', err);
      },
    }
  );
};

export default usePostExerciseListSingleCalculateTax;
